import React from 'react';

interface CardImageProps {
    imageUrl: string;
}

export const CardImage = ({ imageUrl }: CardImageProps) => (
    <div className="card-image">
        <img alt="" className="card-image__image" src={imageUrl} />
    </div>
);
